import currencySymbol from "currency-symbol-map";

export const CurrencySymbol = ({ currency }: { currency: string }) => {
  return <span>{currencySymbol(currency)}</span>;
};
